import React from 'react';
import { View, Dimensions, Text, ScrollView, ActivityIndicator } from 'react-native';
import { ThemeProvider, Button } from 'react-native-elements';

import PanelHeader from './PanelHeader';
import PanelWarriors from './PanelWarriors';
import PanelAbout from './PanelAbout';
import PanelMenu from './PanelMenu';
import PanelSell from './PanelSell';
import PanelMint from './PanelMint';
import PanelManage from './PanelManage';

import Modal from 'modal-enhanced-react-native-web';
import { TouchableOpacity } from 'react-native-web';

import Lib from '../Lib';

const theme = {
  colors: {
    primary: 'dimgray'
  }
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: 'busy',
      modalVisible: false,
      txHash: false,
      warningVisible: true
    };
  }

  async componentDidMount() {
    this.setState({ show: 'home' });
  }

  componentWillUnmount() {
  }

  renderBusy() {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <ActivityIndicator />
      </View>
    );
  }

  handleShow(show) {
    if (show === 'MANAGE') this.setState({ show: 'manage' });
    else if (show === 'MINT') this.setState({ show: 'mint' });
    else if (show === 'SELL') this.setState({ show: 'sell' });
  }

  renderModal() {
    const ww = Dimensions.get('window').width;
    let wh = Dimensions.get('window').height;
    const landscape = (ww > wh);

    let w = ww;
    if (landscape) w = wh * 480 / 800;

    w = Math.round(0.8 * w);

    const msg = 'This is very high risk project. You may lose all your investment.';
    return (
      <Modal
        isVisible={this.state.warningVisible}
        onBackdropPress={() => this.setState({ warningVisible: false })}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ backgroundColor: 'white', padding: 10, width: w }}>
            <Text> </Text>
            <Text style={{ textAlign: 'center' }}>{msg.toUpperCase()}</Text>
            <Text> </Text>
            <Button type="outline" title='I UNDERSTAND' onPress={() => this.setState({ warningVisible: false })} />
            <Text> </Text>
          </View>
        </View>
      </Modal>
    );
  }


  render() {
    const obj = this.state.json;
    if (this.state.show === 'busy') return this.renderBusy();
    if (this.state.show === 'error') return this.renderError();
    const wh = Dimensions.get('window').height;

    let content = (
      <View style={{ flex: 1, backgroundColor: 'gainsboro' }}>
        <ScrollView>
          <PanelAbout />
          <PanelMenu handleShow={show => this.handleShow(show)} />
          <PanelWarriors />
        </ScrollView>
      </View>
    );

    if (this.state.show === 'mint') {
      content = (
        <View style={{ flex: 1, backgroundColor: '#eee' }}>
          <ScrollView>
            <PanelMint
              handleHome={() => this.setState({ show: 'home' })}
            />
          </ScrollView>
        </View>
      );
    } else if (this.state.show === 'sell') {
      content = (
        <View style={{ flex: 1, backgroundColor: '#eee' }}>
          <ScrollView>
            <PanelSell handleHome={() => this.setState({ show: 'home' })} />
          </ScrollView>
        </View>
      );
    } else if (this.state.show === 'manage') {
      content = (
        <View style={{ flex: 1, backgroundColor: '#eee' }}>
          <ScrollView>
            <PanelManage handleHome={() => this.setState({ show: 'home' })} />
          </ScrollView>
        </View>
      );
    }

    const forumUrl = 'https://forum.conflux.fun/t/rtk-warriors-the-first-conflux-project-built-on-top-flux/11202';
    const tgUrl = 'https://t.me/rtkwdao';
    return (
      <ThemeProvider theme={theme}>
        <View style={{ flex: 1 }}>
          {this.renderModal()}
          <View style={{ padding: 5, backgroundColor: 'darkblue' }}>
            <Text style={{ fontWeight: 'bold', color: 'white', textAlign: 'center', fontSize: 10 }}>MAINNET ALPHA</Text>
          </View>
          <PanelHeader />
          {content}
          <View style={{ padding: 10, backgroundColor: 'gray', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <TouchableOpacity onPress={() => Lib.openUrl(forumUrl)}>
              <Text style={{ color: '#ddd' }}>
                FORUM
              </Text>
            </TouchableOpacity>
            <Text style={{ color: '#ddd' }}> | </Text>
            <TouchableOpacity onPress={() => Lib.openUrl(tgUrl)}>
              <Text style={{ color: '#ddd' }}>
                TELEGRAM
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </ThemeProvider>
    );
  }
}

export default Home;
